/**
 *  Copyright (c) 2021-present The TVM Engineering Authors.
 *
 */

const STATIC_ROUTES = {
  signup: "/signup",
  login: "/eo-motcos-login",
  logout: "/logout",
  confirmRegistration: "/confirm-registration",
  removeUser: "/remove-user",
  RegistrationForward: "/registration",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password/:resetToken",
  contacts: "/contacts",
  terms: "/terms",
  privacyPolicy: "/privacy-policy",
  Imprint: "/imprint",
  termsGeneral: "/terms-of-use",
  cookie: "/cookie",
  landingPage: "/",
  admin: "/admin",
  dashboard: "/dashboard",
  support: "/support",
  projects: "/projects",
  projectsTable: "/projects-table",
  uploads: "/uploads",
  profile: "/profile",
  termsAndConditions: "/terms",
  contactUsTechSupport: "/contact-us/tech-support",
  contactUs: "/contact-us",
  errorPage: "/error-page",
  downloadHistory: "/download-history",
  maintenance: "/maintenance",
  shareDownloadLink: "/share-download/:data",
  subscriptionHistory: "/subscription-history",
  registrationHistory: "/registration-history",
};

export default STATIC_ROUTES;
